import { Alert, Box, Button, Modal, SpaceBetween } from "@amzn/awsui-components-react";
import * as React from "react";

export const DeleteKnowledgeBaseModal = (props: {
    visible: boolean;
    loading?: boolean;
    onDismiss: () => void;
    onDelete: () => void;
}) => {
    return (
        <Modal
            visible={props.visible}
            header="Delete Knowledge Base"
            onDismiss={props.onDismiss}
            footer={
                <Box float="right">
                    <Button variant="link" loading={props.loading} onClick={props.onDismiss}>
                        Cancel
                    </Button>
                    <Button variant="primary" loading={props.loading} onClick={props.onDelete}>
                        Confirm
                    </Button>
                </Box>
            }
        >
            <SpaceBetween size="m">
                <Alert type="warning">
                    Deleting the Knowledge Base for this instance cannot be undone.
                </Alert>
                <ul>
                    <li>The current Knowledge Base ARN stops working.</li>
                    <li>
                        Any AI Teammate or other consumer using that ARN must be re-pointed. If you
                        create a Knowledge Base again it gets a <strong>new ARN</strong> — the old one
                        is never reused.
                    </li>
                    <li>
                        Every page's Knowledge Base opt-in in this instance is cleared, so pages have
                        to be opted in again.
                    </li>
                </ul>
                <div>Are you sure you want to delete the Knowledge Base?</div>
            </SpaceBetween>
        </Modal>
    );
};
